<template>
  <layout-main-inner title="扫码统计">
    <layout-card-wrap v-loading="loading">
      <summary-list :span="6"
                    :list="summaryList" />
    </layout-card-wrap>
    <layout-card-wrap style="margin-top:15px"
                      hasHeaderSlot
                      v-loading="loading">
      <template slot="title">按周期统计</template>
      <template slot="form">
        <scantag-form :callBack="getscantagstats" />
      </template>
      <summary-list :span="6"
                    :list="summaryRangeList" />
      <el-card shadow="never"
               style="margin-top:15px">
        <e-charts :options="options"
                  :init-options="{}"
                  ref="charts"
                  autoresize />
      </el-card>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import ScantagForm from './busi/scantag-form.vue'
import SummaryList from './busi/summary.vue'
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import moment from 'moment'
export default {
  name: 'stat-scantag',
  components: { SummaryList, ECharts, ScantagForm },
  data () {
    return {
      loading: false,
      summaryList: [
        {
          label: '累计扫码次数',
          value: 0
        },
        {
          label: '累计扫码标签数量',
          value: 0
        },
        {
          label: '累计涂层验证数量',
          value: 0
        }
      ],
      summaryRangeList: [
        {
          label: '新增扫码次数',
          value: 0
        },
        {
          label: '新增扫码标签数量',
          value: 0
        },
        {
          label: '新增涂层验证数量',
          value: 0
        }
      ],
      options: {
        title: {
          text: '扫码次数/标签数量折线图',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 60,
          top: 60,
          right: 60,
          bottom: 60
        },
        legend: {
          data: ['扫码次数', '扫码标签数量', '涂层验证数量'],
          top: 'bottom'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '扫码次数',
            data: [],
            type: 'line'
          },
          {
            name: '扫码标签数量',
            data: [],
            type: 'line'
          },
          {
            name: '涂层验证数量',
            data: [],
            type: 'line'
          }
        ]
      }
    }
  },
  methods: {
    getscantagstats (payload) {
      this.loading = true
      this.$store.dispatch('stat/getscantagstats', {
        payload,
        success: (res) => {
          this.loading = false
          this.summaryList = [
            {
              label: '累计扫码次数',
              value: res.data.totalScanCount
            },
            {
              label: '累计扫码标签数量',
              value: res.data.totalTagCount
            },
            {
              label: '累计涂层验证数量',
              value: res.data.totalCoatVerifyCount || 0
            }
          ]
          this.summaryRangeList = [
            {
              label: '新增扫码次数',
              value: res.data.scanCount
            },
            {
              label: '新增扫码标签数量',
              value: res.data.tagCount
            },
            {
              label: '新增涂层验证数量',
              value: res.data.coatVerifyCount || 0
            }
          ]
          let xAxisData = res.data.scanTagSumInfos.map(o => {
            if (payload.timeUnit === 'D') {
              return moment(o.scanTime, 'YYYYMMDD').format('YYYY/MM/DD')
            } else if (payload.timeUnit === 'M') {
              return moment(o.scanTime, 'YYYYMM').format('YYYY/MM')
            } else if (payload.timeUnit === 'Y') {
              return moment(o.scanTime, 'YYYY').format('YYYY')
            }
          })
          let series1 = res.data.scanTagSumInfos.map(o => o.scanCount)
          let series2 = res.data.scanTagSumInfos.map(o => o.tagCount)
          let series3 = res.data.scanTagSumInfos.map(o => o.coatVerifyCount || 0)
          this.options.xAxis.data = xAxisData
          this.options.series[0].data = series1
          this.options.series[1].data = series2
          this.options.series[2].data = series3
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
